<template>
	<de-layout-content>
		<el-tabs v-model="activeName" @tab-click="handleTab">
			<el-tab-pane label="管理端" :name="1"></el-tab-pane>
			<el-tab-pane label="客户端" :name="2"></el-tab-pane>
			<el-tab-pane label="APP" :name="3"></el-tab-pane>
		</el-tabs>

		<el-row :gutter="10" class="mb8" style="margin-top:10px;">
			<el-col :span="1.5">
				<el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增菜单</el-button>
			</el-col>
			<el-col :span="1.5">
				<el-button type="default" plain icon="el-icon-sort" size="small" @click="toggleExpandAll">展开/折叠</el-button>
			</el-col>
			<right-toolbar :showSearch.sync="showSearch" @queryTable="_getList"></right-toolbar>
		</el-row>

		<el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" class="ant-advanced-search-form"
			size="small">
			<el-form-item label="菜单名称:" prop="menuName">
				<el-input v-model="queryParams.menuName" placeholder="请输入菜单名称" clearable @keyup.enter.native="handleQuery" />
			</el-form-item>
			<!-- <el-form-item label="状态:" prop="status">
				<el-select v-model="queryParams.status" placeholder="菜单状态" clearable>
					<el-option v-for="dict in dict.type.sys_normal_disable" :key="dict.value" :label="dict.label"
						:value="dict.value" />
				</el-select>
			</el-form-item> -->
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
				<el-button type="default" icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>

		<el-table v-if="refreshTable" v-loading="loading" :data="menuList" row-key="menuId" class="mt20"
			:default-expand-all="isExpandAll" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
			<el-table-column prop="title" label="菜单名称" :show-overflow-tooltip="true" width="160">
			</el-table-column>
			<el-table-column prop="icon" label="图标" align="center" width="100">
				<template slot-scope="scope">
					<svg-icon :icon-class="scope.row.icon" />
				</template>
			</el-table-column>
			<!-- <el-table-column prop="menuSort" label="排序" width="60"></el-table-column> -->
			<el-table-column prop="permission" label="权限标识" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="component" label="组件路径" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column label="显示状态" align="center" width="100">
				<template slot-scope="scope">
					<!-- @change="handleStatusChange(scope.row)" -->
					<el-switch v-model="scope.row.hidden" :active-value="false" :inactive-value="true" disabled></el-switch>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" prop="createTime" min-width="160">
				<template slot-scope="scope">
					<span>{{ parseTime(scope.row.createTime) }}</span>
				</template>
			</el-table-column>
			<el-table-column label="菜单备注" prop="remark" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)" plain>修改
					</el-button>
					<el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd(scope.row)" plain>新增
					</el-button>
					<el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" plain>删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>


		<!-- 添加或修改菜单对话框 -->
		<el-dialog :title="title" :visible.sync="open" width="680px" append-to-body>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="上级菜单">
							<treeselect v-model="form.pid" :options="menuOptions" :normalizer="normalizer" :show-count="true"
								placeholder="选择上级菜单" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="菜单类型" prop="type">
							<el-radio-group v-model="form.type" @change="handleType">
								<el-radio :label="0">目录</el-radio>
								<el-radio :label="1">菜单</el-radio>
								<el-radio :label="-1">操作</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="form.type != -1">
						<el-form-item label="菜单图标">
							<!-- @show="$refs['iconSelect'].reset()" -->
							<el-popover placement="bottom-start" width="460" trigger="click">
								<IconSelect ref="iconSelect" @selected="selected" />
								<el-input slot="reference" v-model="form.icon" placeholder="点击选择图标" readonly>
									<svg-icon v-if="form.icon" slot="prefix" :icon-class="form.icon" class="el-input__icon"
										style="height: 32px;width: 16px;" />
									<i v-else slot="prefix" class="el-icon-search el-input__icon" />
								</el-input>
							</el-popover>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="form.type == -1 ? '操作名称' : '菜单名称'" prop="title">
							<el-input v-model="form.title" placeholder="请输入菜单名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="form.type == -1 ? '操作名' : '菜单名'" prop="name">
							<el-input v-model="form.name" placeholder="请输入菜单名(英文)" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="显示排序" prop="menuSort">
							<el-input-number v-model="form.menuSort" controls-position="right" :min="0" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item>
							<span slot="label">
								<el-tooltip content="选择是外链则路由地址需要以`http(s)://`开头" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								是否外链
							</span>
							<el-radio-group v-model="form.iframe">
								<el-radio :label="true">是</el-radio>
								<el-radio :label="false">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="path">
							<span slot="label">
								<el-tooltip content="访问的路由地址，如:`user`，如外网地址需内链访问则以`http(s)://`开头" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								路由地址
							</span>
							<el-input v-model="form.path" placeholder="请输入路由地址" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="component">
							<span slot="label">
								<el-tooltip content="访问的组件路径，如:`system/user/index`，默认在`views`目录下" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								组件路径
							</span>
							<el-input v-model="form.component" placeholder="请输入组件路径" />
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type != '0'">
						<el-form-item>
							<el-input v-model="form.permission" placeholder="请输入权限标识" maxlength="100" />
							<span slot="label">
								<el-tooltip content="控制器中定义的权限字符，如:@PreAuthorize(`@ss.hasPermi('system:user:list')`)" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								权限字符
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type == '1'">
						<el-form-item>
							<el-input v-model="form.query" placeholder="请输入路由参数" maxlength="255" />
							<span slot="label">
								<el-tooltip content='访问路由的默认传递参数，如:`{"id": 1, "name": "ry"}`' placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								路由参数
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type == '1'">
						<el-form-item>
							<span slot="label">
								<el-tooltip content="选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								是否缓存
							</span>
							<el-radio-group v-model="form.cache">
								<el-radio :label="true">缓存</el-radio>
								<el-radio :label="false">不缓存</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item>
							<span slot="label">
								<el-tooltip content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								显示状态
							</span>
							<el-radio-group v-model="form.hidden">
								<el-radio :label="false">显示</el-radio>
								<el-radio :label="true">隐藏</el-radio>
								<!-- <el-radio v-for="dict in dict.type.sys_show_hide" :key="dict.value" :label="dict.value">
									{{dict.label}}
								</el-radio> -->
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item>
							<span slot="label">
								<el-tooltip content="备注说明菜单功能和开发版本及时间等，仅在后台管理编辑和展示" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								菜单备注
							</span>
							<el-input v-model="form.remark" placeholder="请输入菜单备注" maxlength="255" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</el-dialog>
	</de-layout-content>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "@/components/IconSelect";
import * as API_System from "@/api/train/system";

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/cis";
import { log } from "@antv/g2plot/lib/utils";
export default {
	name: "Menu",
	dicts: ['sys_show_hide', 'sys_normal_disable'],
	components: {
		Treeselect, IconSelect
	},
	data() {
		return {
			activeName: 1,
			// 遮罩层
			loading: true,
			// 显示搜索条件
			showSearch: true,
			// 菜单表格树数据
			menuList: [],
			// 菜单树选项
			menuOptions: [],
			// 弹出层标题
			title: "",
			// 是否显示弹出层
			open: false,
			// 是否展开，默认全部折叠
			isExpandAll: false,
			// 重新渲染表格状态
			refreshTable: true,
			// 查询参数
			queryParams: {
				webType: 1,
				title: undefined,
				visible: undefined,
			},
			// 表单参数
			form: {
				// webType: 1,	//1，管理端 2，客户端
				hidden: false
			},
			// 表单校验
			rules: {
				name: [{ required: true, message: "菜单名称不能为空", trigger: "blur" }],
				title: [{ required: true, message: "菜单名称不能为空", trigger: "blur" }],
				menuSort: [{ required: true, message: "菜单顺序不能为空", trigger: "blur" }],
				path: [{ required: true, message: "路由地址不能为空", trigger: "blur" }]
			}
		};
	},
	created() {
		this._getList();
	},
	methods: {
		handleTab(e) {
			console.log(e.name);
			this.activeName = e.name
			this.queryParams.webType = e.name
			this._getList()
		},
		handleType(e) {
			this.$set(this.form,'path', e == -1 ? '/' : '')
		},
		parseTime,
		// 选择图标
		selected(name) {
			this.form.icon = name;
		},
		/** 查询菜单列表 */
		_getList() {
			this.loading = true;
			API_System.menuList(this.queryParams).then(res => {
				console.log(res);
				this.menuList = handleTree(res.data, "menuId");
				this.loading = false;
			});
		},
		/** 转换菜单数据结构 */
		normalizer(node) {
			if (node.children && !node.children.length) {
				delete node.children;
			}
			return {
				id: node.menuId,
				label: node.title,
				children: node.children
			};
		},
		/** 查询菜单下拉树结构 */
		getTreeselect() {
			API_System.menuList(this.queryParams).then(res => {
				this.menuOptions = [];
				const menu = {
					menuId: 0,
					title: '主类目',
					children: []
				};
				menu.children = handleTree(res.data, "menuId");
				this.menuOptions.push(menu);
			});
		},
		// 取消按钮
		cancel() {
			this.open = false;
			this.reset();
		},
		// 表单重置
		reset() {
			this.form = {
				menuId: undefined,
				pid: 0,
				title: undefined,
				icon: undefined,
				type: 0,
				menuSort: undefined,
				iframe: false,
				cache: false,
				hidden: false,
				status: "0",
				webType: this.activeName
			};
			// this.$refs.form.resetFields();
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this._getList();
		},
		/** 重置按钮操作 */
		resetQuery() {
			// this.$refs.queryForm.resetFields();
			this.handleQuery();
		},
		/** 新增按钮操作 */
		handleAdd(row) {
			this.reset();
			this.getTreeselect();
			if (row != null && row.menuId) {
				this.form.pid = row.menuId;
			} else {
				this.form.parentId = 0;
			}
			this.open = true;
			this.title = "添加菜单";
		},
		/** 展开/折叠操作 */
		toggleExpandAll() {
			this.refreshTable = false;
			this.isExpandAll = !this.isExpandAll;
			this.$nextTick(() => {
				this.refreshTable = true;
			});
		},
		/** 修改按钮操作 */
		handleUpdate(row) {
			this.reset();
			this.getTreeselect();
			API_System.getMenu(row.menuId).then(response => {
				console.log(response);
				this.form = response.data;
				this.open = true;
				this.title = "修改菜单";
			});
		},
		/** 提交按钮 */
		submitForm: function () {
			console.log(this.form);
			// return
			this.$refs["form"].validate(valid => {
				if (valid) {
					// this.form.name = this.form.title
					if (this.form.menuId != undefined) {
						API_System.editMenu(this.form).then(res => {
							console.log(res);
							if (res.success) {
								this.$message.success("修改成功");
								this.open = false;
								this._getList();
							}
						});
					} else {
						API_System.addMenu(this.form).then(res => {
							console.log(res);
							if (res.success) {
								this.$message.success("新增成功");
								this.open = false;
								this._getList();
							}
						});
					}
				}
			});
		},
		/** 删除按钮操作 */
		handleDelete(row) {
			this.$confirm(`确定删除该数据吗？`, "提示", {
				cancelButtonText: "取消",
				confirmButtonText: "确定",
				type: "warning",
			})
				.then(() => {
					API_System.delMenu(row.menuId).then(res => {
						this.$message.success("删除成功");
						this._getList();
					})
				})
				.catch(() => { });
		},
		// 角色状态修改
		handleStatusChange(row) {
			let text = row.status === "0" ? "启用" : "停用";
			this.$message.confirm('确认要' + text + '"' + row.menuName + '"菜单吗？').then(function () {
				return updateMenuSwitch(row.menuId, row.status);
			}).then(() => {
				this.$message.success(text + "成功");
			}).catch(function () {
				row.status = row.status === "0" ? "1" : "0";
			});
		},
	}
};
</script>
<style lang="scss">
// @import "../../../assets/styles/common.scss";
</style>
<style lang="less">
@import "/src/styles/common/common.less";
</style>
